import Api from '../../../helpers/Api';


// ACTION  TYPE
export const ALL_PUBLISHED_PROMOTIONS = 'ALL_PUBLISHED_PROMOTIONS';
const setAllPublishedPromotions = (data) => ({
    type: ALL_PUBLISHED_PROMOTIONS,
    data,
});

export const FEATURED_PROMOTIONS = 'FEATURED_PROMOTIONS';
const setFeaturedPromotions = (data) => ({
    type: FEATURED_PROMOTIONS,
    data,
});

export const CLOSED_PROMOTIONS = 'CLOSED_PROMOTIONS';
const setClosedPromotions = (data) => ({
    type: CLOSED_PROMOTIONS,
    data,
});

export const FILIAIS_PROMOTIONS_PUBLISHED = 'FILIAIS_PROMOTIONS_PUBLISHED';
const setFiliaisWithPromotionsPublished = (data) => ({
    type: FILIAIS_PROMOTIONS_PUBLISHED,
    data,
});


export const IS_FETCHING = 'IS_FETCHING';
const setIsFetching = () => ({
    type: IS_FETCHING,
});

export const END_FETCHING = 'END_FETCHING';
const setEndFetching = () => ({
    type: END_FETCHING,
});

export const fetchAllPublishedPromotionsIfNeeded = () => (dispatch, getState) => {
    const { allPublishedPromotions } = getState().promotions.mainPromotion;

    if (allPublishedPromotions.length > 0) {
        // we have already all the data
        return Promise.resolve(1);
    }

    return Api.progressGet(dispatch, '/api/v1/promotions/getAllPublishedPromotions').then((json) => {
        if (json.status === 'success') {
            // FILTER PROMOTIONS THAT HAVE FEATURED BANNER
            const isFeaturedPromotion = (promotions) => promotions.tx_featuredImageNew != null;
            const featuredPromotions = json.data.filter(isFeaturedPromotion);
            // GET FILIAIS ID WITH PROMOTIONS PUBLISHED
            const filiaisWithPromotionsPublished = [];

            json.data.map((data) => !filiaisWithPromotionsPublished.includes(data.filial) && filiaisWithPromotionsPublished.push(data.filial));

            // SET DATA
            const allPromisse = [
                dispatch(setFiliaisWithPromotionsPublished(filiaisWithPromotionsPublished)),
                dispatch(setAllPublishedPromotions(json.data)),
                dispatch(setFeaturedPromotions(featuredPromotions)),
            ];

            return Promise.all(allPromisse);
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('There has been a problem with your fetch operation: ', error);
    });
};


export const fetchClosedPromotionsIfNeeded = (limit = 6, start = 0) => (dispatch, getState) => {
    const { closedPromotions } = getState().promotions.mainPromotion;

    if (closedPromotions.length > 0 && start === 0) {
        // we have already all the data
        return Promise.resolve(1);
    }

    dispatch(setIsFetching());

    return Api.progressGet(dispatch, `/api/v1/promotions/getClosedPromotions/${limit}/${start}`).then((json) => {
        if (json.status === 'success') {
            return dispatch(setClosedPromotions(json.data));
        }

        throw `error from server: ${json.message}`;
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log('There has been a problem with your fetch operation: ', error);
    }).finally(() => dispatch(setEndFetching()));
};
